/* Zorix — bandeau livraison (sans compte à rebours)
   Le message dit ce qui est vrai : jour d'expédition + délai constaté 24-48 h.
   Plus de compteur en secondes, plus de promesse de livraison J+1.
*/
(function(){
  'use strict';
  var SUB = 'Livraison UPS offerte, 24 à 48 h partout en France métropolitaine.';

  function update(){
    var titleEl = document.getElementById('ship-title');
    if(!titleEl) return;

    var subEl      = document.getElementById('ship-sub');
    var rightEl    = document.getElementById('ship-right');
    var topbarText = document.getElementById('topbar-text');

    if(rightEl){ rightEl.style.display = 'none'; }

    var now  = new Date();
    var day  = now.getDay();
    var hour = now.getHours();
    var isWeekday = day >= 1 && day <= 5;

    if(day === 0 || day === 6 || (day === 5 && hour >= 12)){
      titleEl.textContent = 'Expédition reprise lundi matin';
      if(subEl) subEl.textContent = 'Livraison UPS offerte. Les commandes du week-end partent dès l\'ouverture lundi.';
      if(topbarText) topbarText.innerHTML = 'Expédition lundi matin &middot; livraison offerte partout en France';
      return;
    }

    if(isWeekday && hour < 12){
      titleEl.textContent = 'Commande avant 12 h : expédiée aujourd\'hui';
      if(subEl) subEl.textContent = SUB;
      if(topbarText) topbarText.innerHTML = 'Expédition le jour même avant 12 h &middot; livraison offerte en 24-48 h';
      return;
    }

    titleEl.textContent = 'Commande passée maintenant : expédiée demain';
    if(subEl) subEl.textContent = SUB;
    if(topbarText) topbarText.innerHTML = 'Expédiée demain &middot; livraison offerte en 24-48 h';
  }

  document.addEventListener('DOMContentLoaded', function(){
    update();
    setInterval(update, 60000);
  });
})();